import {Button} from "@k3-tech/react-kit";
import { useRouter } from "@tanstack/react-router";
import { ChevronLeftIcon } from "lucide-react";
import { useCallback } from "react";

export function PageBackButton({
    onBack
}: {
    onBack?: () => void,
}) {
    const router = useRouter();

    const handleClick = useCallback(() => {
        if (onBack == null) {
            router.history.back();
            return;
        }
        onBack();
    }, [onBack, router]);

    return (
        <Button variant="ghost" className="!px-0 cursor-pointer" onClick={handleClick}>
            <ChevronLeftIcon/>
        </Button>
    )
}

export function PageTitleWithBackButton({
    title = "",
    onBack,
}: {
    title?: string,
    onBack?: () => void,
}) {
    return (
        <div className="flex items-center gap-x-2 min-w-0 max-w-full">
            <PageBackButton onBack={onBack} />
            <div className="text-xl sm:text-2xl font-semibold leading-tight break-words min-w-0 flex-1">
                {title}
            </div>
        </div>
    )
}
